import React from "react";
import { styled } from '@mui/styles';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import {
    AppBar as MuiAppBar,
    Toolbar
} from "@mui/material";

import worknestLogo from '../images/myworknest-insignia.svg';

const AppBar = styled(MuiAppBar)(({ theme }) => ({
    background: '#f8f9fa',
    color: ' #12054d',
    boxShadow: theme.shadows[1],
}));

const Header = () => {        

    return (
        (<React.Fragment>
            <AppBar position="sticky" elevation={0}>
                <Toolbar>                    
                    <img alt="worknest logo" src={worknestLogo} style={{ height: '30px' }} />
                    <div style={{ flexGrow: 1 }}></div>
                    <div><strong>Need Help? Call:</strong> <span style={{ color: '#212529' }}>0345 226 8393</span></div>
                    <IconButton size="large"><NotificationsNoneIcon /></IconButton>
                    <IconButton size="large"><MenuIcon /></IconButton>
                </Toolbar>
            </AppBar>
        </React.Fragment>)
    );
}

export default Header;
